import { createAsyncSliceWithDataAndQuery } from './createAsyncSliceWithDataAndQuery';

// QoL function, handles the messiness of having void as the Data type parameter for createAsyncOperationWithDataSlice
export const createAsyncSlice = <Query>(
  name: string,
  action: (x: Query) => Promise<any | void>,
  queryValue: (x: Query) => Partial<Query> = (t) => t
) => createAsyncSliceWithDataAndQuery<Query, void>(name, action, void 0, queryValue);
